import { deleteData, getData, postData } from "./base-api";
import ApiUris from "./apiUris";

/**
 * movable Column Api  method declarations
 */
export const movableColumnApi = {
  getMovableColumn(request) {
    return postData(ApiUris.movableColumnApi.getMovableColumn, request);
  },
  createMovableColumn(request) {
    return postData(ApiUris.movableColumnApi.createMovaleColumn, request);
  },
  editMovableColumn(request) {
    return postData(ApiUris.movableColumnApi.updateMovaleColumn, request);
  },
};
